import { ISystemAccessLog } from 'features/settings/versions/types';
import { BaseService } from 'shared/services/BaseService';

class SystemAccessLogService extends BaseService<ISystemAccessLog> {
  constructor() {
    super('access-logs');
  }
}

export const systemAccessLogService = new SystemAccessLogService();
